import type { SpecificMapWithDefault } from '../types'
const withDefault = <K extends number | string | symbol, V>(
  map: SpecificMapWithDefault<K, V>,
  key: K | undefined
): V => map[key ?? '*'] ?? map['*']

export default withDefault
